import styled, { css } from 'styled-components'

export const CheckboxContainer = styled.div`
  // Remove checkbox label margin
  & > label {
    margin-right: 0;

    & > span {
      ${props =>
        props.padding &&
        css`
          padding: ${props.padding};
        `}
    }
  }
`
